/**
 * Created by raoulzander on 09.06.17.
 */
export class RecipeListingPageController {
    constructor($scope, contentUtilService) {
        'ngInject';

        contentUtilService.markAndTrustContentAsHtml($scope.content, 'body');
    }
}